module.exports = __webpack_public_path__ + "ff91d4e29d7ad3ac065641771e5adead.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-74.cur
// module id = 475
// module chunks = 0